/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import { ICreateUser, IUpdateUser } from "../models/user.model";

export const getUsers = async (payload: { page: number; limit: number; status?: number; keyword?: string }) => {
  const res = await axios.get("/user/", { params: payload });
  return res;
};

export const createUser = async (payload: ICreateUser) => {
  const res = await axios.post("/user/create", payload);
  return res;
};

export const updateUser = async (id: string, payload: IUpdateUser) => {
  const res = await axios.patch(`/user/${id}`, payload);
  return res;
};
